"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
exports.clamp = function (min, value, max) {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
};
